import {
  AttachMoney,
  DiamondOutlined,
  History,
  Home,
  Link,
  Logout,
  Payments,
  HealthAndSafety,
  LocalHospital,
  AccountBalance,
  RequestQuote,
  AccountBalanceWallet,
  VerifiedUser,
} from "@mui/icons-material";

export const SideBarItems = [
  {
    Icon: <Home sx={{ height: "18px", width: "18px" }} />,
    path: "/dashboard",
    title: "Dashboard",
    active: true,
  },
  {
    Icon: <HealthAndSafety sx={{ height: "18px", width: "18px", color: "#059669" }} />,
    path: "/insurance-policy",
    title: "Insurance",
    active: true,
    isInsurance: true,
  },
  {
    Icon: <LocalHospital sx={{ height: "18px", width: "18px", color: "#059669" }} />,
    path: "/hospi-cash",
    title: "HospiCash",
    active: true,
    isInsurance: true,
  },
  {
    Icon: <RequestQuote sx={{ height: "18px", width: "18px" }} />,
    path: "/loans",
    title: "Loans",
    active: true,
    isFinance: true,
  },
  {
    Icon: <AccountBalanceWallet sx={{ height: "18px", width: "18px" }} />,
    path: "/wallet",
    title: "Wallet",
    active: true,
    isFinance: true,
  },
  {
    Icon: <Payments sx={{ height: "18px", width: "18px" }} />,
    path: "/transactions",
    title: "Transactions",
    active: true,
  },
  {
    Icon: <AttachMoney sx={{ height: "18px", width: "18px" }} />,
    path: "/withdrawal-history",
    title: "Withdrawal History",
    active: true,
  },
  {
    Icon: <History sx={{ height: "18px", width: "18px" }} />,
    path: "/withdrawal",
    title: "Withdrawal",
    active: true,
  },
  {
    Icon: <DiamondOutlined sx={{ height: "18px", width: "18px" }} />,
    path: "/hubs",
    title: "Hubs",
    active: true,
  },
  {
    Icon: <AccountBalance sx={{ height: "18px", width: "18px" }} />,
    path: "/chartered-accountant",
    title: "CA Registration",
    active: true,
  },
  {
    Icon: <Link sx={{ height: "18px", width: "18px" }} />,
    path: "/form-responses-submitted",
    title: "Form Responses",
    active: true,
  },
];

export const sideBarBottomItems = [
  {
    Icon: <VerifiedUser sx={{ height: "18px", width: "18px" }} />,
    path: "/profile",
    title: "KYC & Settings",
    active: true,
  },
  {
    Icon: <Logout sx={{ height: "18px", width: "18px" }} />,
    title: "Logout",
    onClick: () => {
      localStorage.removeItem("Token");
      localStorage.removeItem("Role");
      localStorage.removeItem("user_details");
      window.location.href = "/signin";
    },
  },
];
